import { http, useVzFetch } from '~/composables/useVzFetch';

export function getTariffs(body: {from: string[], to: string[], orgId?: string|string[]}) {
  return useVzFetch(
    `${http}/tariff/get`,
    { method: 'POST', body }
  ) as Promise<string[]>
}
